import { useQuery } from "@tanstack/react-query";
import { fetchAwaitingEvidence } from "@/api/metadata";
import type {
  AwaitingEvidenceItem,
  AwaitingEvidenceTarget,
} from "../models/awaitingEvidence";

export const AWAITING_EVIDENCE_QUERY_KEY = [
  "cle-compliance",
  "status",
  "awaiting-evidence",
] as const;

/**
 * Dokumentation, der afventer behandling og kan tælle i perioden, så indberetningsflowet
 * kan advare, før advokaten indberetter. Advarslen må aldrig spærre indberetningen: fejler
 * opslaget, er der blot ingen data, og flowet åbner som normalt.
 */
export const useAwaitingEvidence = (target: AwaitingEvidenceTarget) =>
  useQuery<AwaitingEvidenceItem[]>({
    queryKey: [...AWAITING_EVIDENCE_QUERY_KEY, target.kind, target.id],
    queryFn: () => fetchAwaitingEvidence(target),
    enabled: Boolean(target.id),
    // Status skal være, som den er nu, når flowet åbnes — ikke fra en tidligere visning.
    staleTime: 0,
    retry: 1,
  });
